import { Typography, useTheme } from '@mui/material';

import { Card } from 'src/components';
import { Flex } from 'src/components/Flex';
import DisplayText from 'src/features/finance/sepaDirectDebits/components/BillingDetails/DisplayText';
import { formatDate } from 'src/utils/utils';

interface RecurringInvoiceConfigurationProps {
    invoiceOccurrence: string;
    invoiceOccurrenceType: string;
    invoiceFrequency: number;
    recurringStartDate: Date;
}

function RecurringInvoiceConfiguration({
    invoiceFrequency,
    invoiceOccurrence,
    invoiceOccurrenceType,
    recurringStartDate,
}: RecurringInvoiceConfigurationProps) {
    const theme = useTheme();

    return (
        <Card color={theme.palette.text.primary} flex={1} gap="24px">
            <Typography fontSize="20px" fontWeight="500" lineHeight="30px">
                Recurring Invoice Configuration
            </Typography>
            <Flex alignItems="flex-start">
                <DisplayText
                    label="Invoice Occurrence"
                    value={invoiceOccurrence?.replace(/_/, ' ')}
                />
                <DisplayText label="Invoice Frequency" value={invoiceFrequency?.toString()} />
            </Flex>
            <Flex alignItems="flex-start">
                <DisplayText
                    label="Occurrence Type"
                    value={invoiceOccurrenceType?.replace(/_/g, ' ')}
                />
                <DisplayText
                    label="Recurring Start Date"
                    value={formatDate({ date: recurringStartDate })}
                />
            </Flex>
        </Card>
    );
}
export default RecurringInvoiceConfiguration;
